import { DeviceMetadata } from "./device-metadata";

export class MeasurementViewModel {
	name: string;
	data: any;
	metadata: DeviceMetadata;
	deviceStyle: string;
	styles: any;
	properties: any;
	//messages: Map<string,string> = new Map<string, string>();
	warningMessages: Array<string>;
	//timestamp: Date;
}



